import React from 'react'
import StronaDokumentu, { NaglowekSekcji } from './StronaDokumentu'

/**
 * „Twoja instalacja na dachu”: widok z góry z Projektu 3D z modułami pokolorowanymi według rocznej straty
 * z cienia i tabela połaci (kierunek, kąt, liczba modułów). Strona jest tylko wtedy, gdy klient ma model 3D
 * i ujęcie się udało (`hooks/useUjecie3D`).
 */

const KIERUNKI = ['północ', 'północny wschód', 'wschód', 'południowy wschód', 'południe', 'południowy zachód', 'zachód', 'północny zachód']
const kierunek = (az) => KIERUNKI[Math.round((((az % 360) + 360) % 360) / 45) % 8]
const LEGENDA = [['#22c55e', 'do 3%'], ['#84cc16', '3–8%'], ['#eab308', '8–15%'], ['#f97316', '15–25%'], ['#ef4444', 'ponad 25%']]

const StronaInstalacji = ({ ujecie, nazwaFirmy, numer, zeStron, podtytul }) => {
  const pola = ujecie?.pola || []
  const strata = ujecie?.strataCienia
  return (
    <StronaDokumentu numer={numer} zeStron={zeStron} nazwaFirmy={nazwaFirmy} podtytul={podtytul}>
      <NaglowekSekcji
        tytul="Twoja instalacja na dachu"
        opis={`Model budynku z danych GUGiK z ułożonymi modułami.${strata == null ? ''
          : strata < 0.005 ? ' Cień drzew i budynków obok praktycznie nie zabiera energii.'
            : ` Cień drzew i budynków obok zabiera w roku ok. ${String(Math.round(strata * 1000) / 10).replace('.', ',')}% energii.`}`}
      />
      {ujecie?.zGory && (
        <figure className="mb-5">
          <img src={ujecie.zGory} alt="Widok dachu z góry z modułami pokolorowanymi według straty z cienia"
               className="w-full rounded-xl border border-gray-200 object-cover aspect-[16/10] print:max-h-[118mm]" />
          <figcaption className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-gray-600">
            <span className="font-semibold text-gray-800">Strata z cienia w roku:</span>
            {LEGENDA.map(([kolor, opis]) => (
              <span key={opis} className="inline-flex items-center gap-1 tabular-nums">
                <span className="h-2.5 w-2.5 rounded-sm" style={{ background: kolor }} />{opis}
              </span>
            ))}
          </figcaption>
        </figure>
      )}
      {pola.length > 0 && (
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 text-left text-xs text-gray-500">
              <th className="py-1.5 font-medium">Połać</th>
              <th className="py-1.5 font-medium">Kierunek</th>
              <th className="py-1.5 text-right font-medium">Kąt</th>
              <th className="py-1.5 text-right font-medium">Moduły</th>
            </tr>
          </thead>
          <tbody>
            {pola.map((p, i) => (
              <tr key={i} className="border-b border-gray-100">
                <td className="py-1.5 text-gray-900">{p.nazwa || `Połać ${i + 1}`}</td>
                <td className="py-1.5 text-gray-700">{kierunek(p.azymut)}</td>
                <td className="py-1.5 text-right tabular-nums text-gray-700">{p.nachylenie}°</td>
                <td className="py-1.5 text-right font-semibold tabular-nums text-gray-900">{p.liczba}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </StronaDokumentu>
  )
}

export default StronaInstalacji
